(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getSafeComparePrice(base, compare) {
    if (compare && compare > base) return compare;
    if (base > 0) return Math.round(base / 0.7);
    return 0;
  }

  function initWidget(widget) {
    var blockId = widget.dataset.blockId;
    var sectionId = widget.dataset.sectionId;
    var variantsEl = document.getElementById('vdb-variants-' + blockId);
    var variants = [];

    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (error) {
        variants = [];
      }
    }
    var moneyFormat = widget.dataset.moneyFormat || '${{amount}}';
    var costLabel = widget.dataset.costPerItemLabel || 'Cost per item.';
    var saveLabel = widget.dataset.saveLabel || 'SAVE';
    var enableVariantSelection = widget.dataset.enableVariantSelection === 'true';
    var hideDefaultVariant = widget.dataset.hideDefaultVariant === 'true';
    var updateCartButton = widget.dataset.updateCartButton === 'true';
    var defaultQty = parseInt(widget.dataset.defaultQuantity, 10) || 1;

    var basePrice = parseInt(widget.dataset.basePrice, 10) || 0;
    var comparePrice = parseInt(widget.dataset.comparePrice, 10) || 0;

    var packages = widget.querySelectorAll('.vdb-package');
    var variantSection = widget.querySelector('.vdb-variant-section');
    var variantSelectorsEl = widget.querySelector('.vdb-variant-selectors');
    var scope =
      (sectionId && document.getElementById('shopify-section-' + sectionId)) ||
      widget.closest('[id^="shopify-section-"]') ||
      document;
    var form =
      scope.querySelector('form[action="/cart/add"]') ||
      scope.querySelector('form[action^="/cart/add"]') ||
      document.querySelector('form[action="/cart/add"]');

    var qtyInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');
    var variantPicker = scope.querySelector('.product-detail__variant-picker');
    var addBtn = form ? form.querySelector('.product-form__submit .btn-label') : document.querySelector('.product-form__submit .btn-label');
    var variantIdInput = form
      ? form.querySelector('input[name="id"].product-variant-id, input[name="id"]')
      : document.querySelector('input[name="id"].product-variant-id, input[name="id"]');

    var selectedQty = defaultQty;
    var selectedVariantIds = [];
    var multiCartBound = false;

    function getSelectedPackage() {
      return widget.querySelector('.vdb-package.selected');
    }

    function getPerItemPrice(pkg) {
      var discount = parseFloat(pkg.dataset.discountFromCompare) || 0;
      var useBase = pkg.dataset.useBasePrice === 'true';
      var safeCompare = getSafeComparePrice(basePrice, comparePrice);

      if (useBase) return basePrice;
      return Math.round(safeCompare * (1 - discount / 100));
    }

    function updatePackagePrices() {
      var safeCompare = getSafeComparePrice(basePrice, comparePrice);

      packages.forEach(function (pkg) {
        var discount = parseFloat(pkg.dataset.discountFromCompare) || 0;
        var perItem = getPerItemPrice(pkg);
        var priceEl = pkg.querySelector('.discounted-price');
        var compareEl = pkg.querySelector('.regular-price');
        var saveEl = pkg.querySelector('.vdb-package__save-text');

        if (priceEl) priceEl.textContent = formatMoney(perItem, moneyFormat);
        if (compareEl) {
          compareEl.textContent = formatMoney(safeCompare, moneyFormat);
          compareEl.style.display = safeCompare > perItem ? '' : 'none';
        }
        if (saveEl) saveEl.textContent = saveLabel + ' ' + discount + '%';
      });

      updateCartButtonPrice();
    }

    function updateCartButtonPrice() {
      if (!updateCartButton || !addBtn) return;
      var pkg = getSelectedPackage();
      if (!pkg) return;
      var perItem = getPerItemPrice(pkg);
      var total = perItem * selectedQty;
      var baseText = addBtn.dataset.originalLabel;

      if (!baseText) {
        baseText = addBtn.textContent.trim();
        addBtn.dataset.originalLabel = baseText;
      }

      var label = baseText.replace(/\s*[•·\-–—]\s*\$[\d,.]+.*$/i, '').trim();
      addBtn.textContent = label + ' • ' + formatMoney(total, moneyFormat);
    }

    function updateBundleImages(variant) {
      if (!variant) return;
      ['1', '2', '3'].forEach(function (key) {
        var img = widget.querySelector('.bundle-img[data-image-type="' + key + '"]');
        if (!img) return;
        var mfUrl = variant.metafields && variant.metafields[key + '_product_image'];
        var src = mfUrl || variant.featured_image || null;
        if (src) img.src = src;
      });
    }

    function setQuantity(qty) {
      selectedQty = qty;
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function toggleDefaultVariantPicker(show) {
      if (!variantPicker || !hideDefaultVariant) return;
      variantPicker.style.display = show ? '' : 'none';
      if (qtyInput) qtyInput.disabled = !show;
    }

    function buildVariantSelectors(qty) {
      if (!enableVariantSelection || !variantSection || !variantSelectorsEl) return;

      if (qty <= 1) {
        variantSection.hidden = true;
        variantSelectorsEl.innerHTML = '';
        selectedVariantIds = [];
        toggleDefaultVariantPicker(true);
        return;
      }

      variantSection.hidden = false;
      toggleDefaultVariantPicker(false);
      variantSelectorsEl.innerHTML = '';
      variantSelectorsEl.classList.toggle('vdb-variant-selectors--cols-3', qty >= 3);
      selectedVariantIds = [];

      for (var i = 1; i <= qty; i++) {
        (function (index) {
          var field = document.createElement('div');
          field.className = 'vdb-variant-field';

          var label = document.createElement('label');
          label.className = 'vdb-variant-field__label';
          label.textContent = '#' + index + ':';
          label.setAttribute('for', 'vdb-select-' + blockId + '-' + index);

          var select = document.createElement('select');
          select.className = 'vdb-variant-field__select bundle-select';
          select.id = 'vdb-select-' + blockId + '-' + index;

          variants.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + (v.available ? '' : ' (Out of stock)');
            opt.disabled = !v.available;
            select.appendChild(opt);
          });

          var firstAvailable = Array.prototype.find.call(select.options, function (o) {
            return !o.disabled;
          });
          if (firstAvailable) select.value = firstAvailable.value;
          selectedVariantIds[index - 1] = select.value;

          select.addEventListener('change', function () {
            selectedVariantIds[index - 1] = select.value;
          });

          field.appendChild(label);
          field.appendChild(select);
          variantSelectorsEl.appendChild(field);
        })(i);
      }

      bindMultiVariantCart();
    }

    function bindMultiVariantCart() {
      if (multiCartBound) return;
      if (!form) return;

      // Use capture + stopImmediatePropagation to prevent theme-level global /cart/add interceptors.
      form.addEventListener(
        'submit',
        function (e) {
          var pkg = getSelectedPackage();
          if (!pkg) return;

          var pkgQty = parseInt(pkg.dataset.quantity, 10) || 1;

          // Always ensure the form quantity matches the selected package (for other scripts / accessibility).
          setQuantity(pkgQty);

          // We always handle add-to-cart here so we can reliably redirect to /cart.
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

          var submitBtn = form.querySelector('.product-form__submit');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.classList.add('loading');
          }

          function done(ok) {
            if (ok) {
              window.location.href = '/cart';
              return;
            }
            alert('Something went wrong while adding to cart.');
          }

          // Multi-variant bundles (qty > 1) add one line per chosen variant.
          if (enableVariantSelection && pkgQty > 1) {
            var ids = selectedVariantIds.filter(Boolean);
            if (ids.length !== pkgQty) {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.classList.remove('loading');
              }
              alert('Please select a variant for each item.');
              return;
            }

            var chain = Promise.resolve();
            ids.forEach(function (id) {
              chain = chain.then(function () {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: id, quantity: 1 })
                }).then(function (res) {
                  if (!res.ok) throw res;
                  return res.json();
                });
              });
            });

            chain
              .then(function () {
                done(true);
              })
              .catch(function () {
                done(false);
              })
              .finally(function () {
                if (submitBtn) {
                  submitBtn.disabled = false;
                  submitBtn.classList.remove('loading');
                }
              });

            return;
          }

          // Single-variant (or qty 1) add with selected package quantity.
          var id = variantIdInput ? variantIdInput.value : null;
          if (!id) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('loading');
            }
            done(false);
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: id, quantity: pkgQty })
          })
            .then(function (res) {
              if (!res.ok) throw res;
              return res.json();
            })
            .then(function () {
              done(true);
            })
            .catch(function () {
              done(false);
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.classList.remove('loading');
              }
            });
        },
        true
      );

      multiCartBound = true;
    }

    function selectPackage(pkg) {
      packages.forEach(function (p) {
        p.classList.remove('selected');
      });
      pkg.classList.add('selected');

      var qty = parseInt(pkg.dataset.quantity, 10) || 1;
      setQuantity(qty);
      buildVariantSelectors(qty);
      updateCartButtonPrice();
    }

    packages.forEach(function (pkg) {
      pkg.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        selectPackage(pkg);
      });
    });

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;

      basePrice = v.price || 0;
      comparePrice = v.compare_at_price || 0;
      widget.dataset.basePrice = basePrice;
      widget.dataset.comparePrice = comparePrice;

      updatePackagePrices();

      var mapped = variants.find(function (item) {
        return String(item.id) === String(v.id);
      });
      updateBundleImages(mapped || v);
    });

    updatePackagePrices();

    var initial = widget.querySelector('.vdb-package.selected') || packages[0];
    if (initial) {
      selectPackage(initial);
    } else if (packages.length) {
      selectPackage(packages[0]);
    }

    var currentVariantId = variantIdInput ? variantIdInput.value : null;
    if (currentVariantId) {
      var current = variants.find(function (v) {
        return String(v.id) === String(currentVariantId);
      });
      if (current) updateBundleImages(current);
    }
  }

  function boot() {
    document.querySelectorAll('.vdb-widget').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
